import {Injectable} from '@angular/core';
import {CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../auth/auth.service';

@Injectable()
export class UnauthenticatedGuard implements CanActivate {
  constructor(public authService: AuthService, private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.authService.isAuthenticated()) {
      return true;
    }
    this.router.navigate(['home']);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guards/unauthenticated.guard.ts